import React from "react";
import { useTranslation } from "react-i18next";
import { Clock, CheckCircle2, XCircle } from "lucide-react";
import { Card, CardContent } from "../ui/card";

const OverrideSummaryCards = ({ summary }) => {
  const { t } = useTranslation();
  if (!summary) return null;
  return (
    <div className="grid grid-cols-3 gap-4">
      <Card>
        <CardContent className="pt-6">
          <div className="flex items-center gap-3">
            <Clock className="h-8 w-8 text-yellow-500" />
            <div>
              <p className="text-2xl font-bold">{summary.pending_count}</p>
              <p className="text-xs text-muted-foreground">{t("planning.overridesPanel.summary.pending")}</p>
            </div>
          </div>
        </CardContent>
      </Card>
      <Card>
        <CardContent className="pt-6">
          <div className="flex items-center gap-3">
            <CheckCircle2 className="h-8 w-8 text-green-500" />
            <div>
              <p className="text-2xl font-bold">{summary.approved_count}</p>
              <p className="text-xs text-muted-foreground">{t("planning.overridesPanel.summary.approved")}</p>
            </div>
          </div>
        </CardContent>
      </Card>
      <Card>
        <CardContent className="pt-6">
          <div className="flex items-center gap-3">
            <XCircle className="h-8 w-8 text-red-500" />
            <div>
              <p className="text-2xl font-bold">{summary.rejected_count}</p>
              <p className="text-xs text-muted-foreground">{t("planning.overridesPanel.summary.rejected")}</p>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default OverrideSummaryCards;
